export default __webpack_public_path__ + "static/media/logo_black.6102a182.svg";